import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import {
  setSymbolActive,
  setSymbolScroll,
} from '../../containers/client/actions';
import { makeGetCWList, makeGetSnapShotCW } from '../../lib/selector';
import DatagridRowGroupCW from './DatagridRowGroupCW';

import * as _ from 'lodash'

function DatagridGroupCW(props) {
  const dispatch = useDispatch();

  const {
    symScroll,
    resource,
    children,
    className,
    isPc,
    cwList,
    snapshotCW,
  } = props;

  useEffect(() => {
    if (symScroll) {
      // console.log(symScroll)
      scrollTo(symScroll);
      dispatch(setSymbolScroll(null));
    }
  }, [symScroll]);

  const scrollTo = (id) => {
    let _rootRow = document.getElementById(id + 'row');
    if (_rootRow) {
      _rootRow.scrollIntoView();
      _rootRow.classList.add('bg-active');
      setTimeout(() => {
        if (_rootRow) _rootRow.classList.remove('bg-active');
      }, 1500);
    }
  };

  const handleOpenModal = (sym) => {
    dispatch(setSymbolActive(sym));
  };

  return (
    <table className={className + ''}>
      <colgroup>
        <col width="6%" />
        <col width="3.9%" />
        <col width="5.2%" />
        <col width="2.5%" />
        <col width="2.5%" />
        <col width="2.5%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.0%" />
        <col width="3.3%" />
        <col width="3%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.5%" />
        <col width="3.2%" />
        <col width="3.2%" />
        <col width="3.1%" />
        <col width="3.1%" />
        <col width="4.2%" />
        <col width="3%" />
        <col width="3%" />
        <col width="3.0%" />
        <col width="3.5%" />
      </colgroup>
      {children && <thead className="bb-1-haft ">{children}</thead>}
      <tbody>
        {resource &&
          !!resource.length &&
          resource.map((item, index) => {
            return (
              <DatagridRowGroupCW
                record={item}
                key={`${item.sym}-${index}`}
                isPc={isPc}
                handleOpenModal={handleOpenModal}
                cwList={cwList}
                snapshotCW={snapshotCW}
              />
            );
          })}
      </tbody>
    </table>
  );
}

const mapStateToProps = (state) => {
  // console.log(state.client)
  const getCWList = makeGetCWList();
  const getSnapShotCW = makeGetSnapShotCW();
  return {
    symScroll: state.client.symbolScroll,
    cwList: getCWList(state),
    snapshotCW: getSnapShotCW(state),
  };
};

export default connect(mapStateToProps)(DatagridGroupCW);
